export class AccountFormatInvalidException extends Error {}
